import { useEffect } from "react";
import { useResponsiveMobile } from "../../hooks/useResponsiveMobile";
import { Section1 } from "./component/Section1";
import { Section2 } from "./component/Section2";
import { Section3 } from "./component/Section3";
import { setDescription } from "../../seo/seo";
import Banner from "../../component/Banner";

const ExpectedEffect = () => {
  const isMobile = useResponsiveMobile(900);
  useEffect(() => {
    document.title = "품 : Poom | 도입효과";
    setDescription(
      "수작업 없이 이루어지는 자동화된 정산 환경을 경험하세요. 운영 시간 단축을 통해 확보한 여력을 비즈니스 확장에만 집중할 수 있습니다.",
    );
  }, []);
  return (
    <div
      style={{ wordBreak: "keep-all" }}
      className="relative w-full flex flex-col gap-10 overflow-hidden"
    >
      <img
        src="/assets/images/effect/background_left.png"
        alt=""
        className="md:flex hidden absolute top-[300px] left-0 z-0 pointer-events-none select-none max-h-[2763px]"
      />

      {!isMobile ? (
        <img
          src={"/assets/images/effect/background_right.png"}
          alt=""
          className="
  md:max-h-[2763px]
  absolute
  top-[-150px]
  md:top-[300px]
  z-0
  pointer-events-none
  select-none
  right-0
  "
        />
      ) : (
        <>
          <img
            src="/assets/images/effect/bg_mobile_top.png"
            alt=""
            className="
              absolute 
              top-[1050px] 
              right-0 
              z-0 
              pointer-events-none 
              select-none 
              max-h-[1041px]"
          />

          <img
            src="/assets/images/effect/bg_mobile_bottom.png"
            alt=""
            className="
              absolute 
              bottom-[900px] 
              right-0 
              z-0 
              pointer-events-none 
              select-none 
              max-h-[968px]"
          />
        </>
      )}

      {/*  실제 콘텐츠 */}
      <div className="relative z-10 w-full flex flex-col gap-20 md:gap-40">
        <div className="flex flex-col gap-[120px] md:gap-[160px]">
          <section className="w-full flex flex-col pt-6 md:pt-3 justify-center items-center px-6">
            <Banner
              pcImage="/assets/images/effect/bg.webp"
              mobileImage="/assets/images/effect/bg_mobile.webp"
            >
              <span className="text-black font-bold text-[20px] md:text-display3 text-center">
                정산 업무가 스마트해지면, <br />
                비즈니스는 당연히 성장합니다!
              </span>
            </Banner>
          </section>

          <Section1 />
          <Section2 />
        </div>

        <Section3 />
      </div>
    </div>
  );
};

export default ExpectedEffect;
